var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var Svg4 = function Svg4(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "abd466ad-a616-4b27-b275-9790b2642ef8",
    "data-name": 4,
    width: 52.68,
    height: 69.99,
    viewBox: "0 0 52.68 69.99",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M47.67,42.47V52.92H39.98V67.54H26.9V52.92H0V41.25L24.98,0h15V42.47Zm-37.78,0H26.91V13.12Z",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.98,42.47V0h-15L5,41.25V52.92H31.91V67.54H44.99V52.92h7.69V42.47h-7.7Zm6.69,1H44.98a1,1,0,0,1-1-1V1H30.54L6,41.53V51.92H31.91a1,1,0,0,1,1,1V66.54H43.99V52.92a1,1,0,0,1,1-1h6.69V43.47Zm-37.65-.5a.993.993,0,0,1,0-1L31.04,12.63a1,1,0,0,1,1.86.51V42.48a1,1,0,0,1-1,1H14.89a1,1,0,0,1-.87-.5Zm17.88-.5H14.89L31.91,13.13V42.47Z",
    style: {
      fill: "currentColor",
      fillRule: "evenodd"
    }
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg4, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/4.ac303b4d.svg";
export { ForwardRef as ReactComponent };